import { type IObjectValidationDescription } from '@framework/validation/describe/describeSchema.ts';
import {
  type IEngineSectionStatus,
  SectionsStatusKey,
} from './SectionStatusSchema.ts';

/**
 * Serializza lo status delle sezioni in un oggetto che viene inserito
 * nella _root_ del JSON serializzato del form.
 */
export function serializeFormSectionsStatus(
  schema: IObjectValidationDescription,
) {
  // Controlliamo se esiste lo status delle sezioni
  const statusSchema = schema.schemas[SectionsStatusKey];

  if (!statusSchema) return {};
  const status = statusSchema.value as Record<string, IEngineSectionStatus>;
  return { sections: status };
}

export function deserializeFormSectionStatus(
  sections: Record<string, IEngineSectionStatus> | undefined,
) {
  if (!sections) return undefined;
  return {
    [SectionsStatusKey]: sections,
  };
}
